<template>
  <!-- Sits next to (not inside) switches: disabled Vuetify inputs swallow hover events -->
  <v-tooltip
    bottom
    max-width="320"
  >
    <template #activator="{ on, attrs }">
      <v-icon
        small
        class="ml-1 help-tooltip-icon"
        v-bind="attrs"
        v-on="on"
        @click.stop
      >
        {{ mdiInformationOutline }}
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
import { mdiInformationOutline } from '@mdi/js'

export default {
  name: 'HelpTooltip',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return { mdiInformationOutline }
  }
}
</script>

<style scoped>
.help-tooltip-icon {
  cursor: help;
}
</style>
